<template>
  <td
      class="min-w-0 flex-1 flex items-center justify-between sm:pl-6 px-6 py-4"
      @click="$router.push(promotionType())"
  >
    <div>
      <div class="text-sm text-gray-900">{{ name }}</div>
      <div class="text-sm text-gray-500">
        <div class="flex items-center text-sm text-gray-500">
          <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd" />
          </svg>
          <p>
            <time datetime="2021-09-09T10:00:00.000" v-html="date +'h'"></time>
          </p>

          <span class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
            Zakazana
          </span>
          <span
              class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
              :style="{
              'color': 'white',
              'background-color': id == 1 ? '#0eacd8' : id == 2 ? '#06d8e0' : '#7e07df'
              }"
          >
            {{ type !== 'Dermokonsultacija' ? type : 'Dermo' }}
          </span>

        </div>
      </div>
    </div>
    <div>
      <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
      </svg>
    </div>
  </td>
</template>

<script>
import Promotion from './Promotion';
export default Promotion;
</script>